import defaultConfig from './config';

class GetFtr {
    constructor(config = defaultConfig) {
        this.config = config;
    }

    initialize() {
        throw new Error("GetFtr parent class can't be initialized.");
    }

    _curateButtons(selector) {
        if (!selector) return;
        return Array.from(document.querySelectorAll(selector)).reduce((acc, button) => {
            const a = button.firstChild;
            a.innerText = this.config.labels.button;
            const doi = a.href.match(this.config.buttons.doiRegex);
            if (doi) {
                acc[decodeURIComponent(doi[0])] = button;
            }
            return acc;
        }, {});
    }

    async _fetchRequest(endpoint, dois, priority = 'auto') {
        const url = new URL(endpoint, window.location.origin);
        url.searchParams.set('dois', dois.join(','));
        const response = await fetch(url, {signal: AbortSignal.timeout(5000), priority: priority});
        return await response.json();
    }

    static initializeTooltip (trigger, tooltip, options = {}) {
        if (!trigger || !tooltip) return;
        options = {
            spacing: 18,
            ...options
        };
        const showTooltip = () => {
            tooltip.classList.remove('tooltip-bottom');
            tooltip.classList.add('tooltip-visible');

            const triggerRect = trigger.getBoundingClientRect();
            const tooltipRect = tooltip.getBoundingClientRect();

            const fitsTop = triggerRect.top >= tooltipRect.height + options.spacing;
            const top = fitsTop
                ? window.scrollY + triggerRect.top - tooltipRect.height - options.spacing
                : window.scrollY + triggerRect.bottom + options.spacing;
            const left = window.scrollX + triggerRect.left + (triggerRect.width / 2) - (tooltipRect.width / 2);

            tooltip.style.top = `${top}px`;
            tooltip.style.left = `${left}px`;
            if (!fitsTop) {
                tooltip.classList.add('tooltip-bottom');
            }
        }
        const hideTooltip = () => {
            tooltip.classList.remove('tooltip-visible');
        };

        if (!tooltip.id) tooltip.id = `tooltip-${Math.random().toString(16).slice(2)}`;
        trigger.setAttribute('aria-describedby', tooltip.id);
        tooltip.setAttribute('role', 'tooltip');

        trigger.addEventListener('mouseenter', showTooltip);
        trigger.addEventListener('touchstart', showTooltip);
        trigger.addEventListener('focus', showTooltip);

        trigger.addEventListener('mouseleave', hideTooltip);
        trigger.addEventListener('blur', hideTooltip);
        trigger.addEventListener('keydown', (e) => {
            if (e.key === 'Escape') {
                hideTooltip();
            }
        });
    }
}
export default GetFtr;
